import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as routeBound from '../../../route-bound'
import type { Feature } from '../feature'

/**
 * Executes upsert requests against the survey configuration API
 */
export const upsertOnRequest = store.effects.create(
  (feature: Feature, context$: routeBound.scenario.Context.Stream) =>
    feature.actions.upsert.request.observe().pipe(
      rxjs.withLatestFrom(
        context$,
        feature.selectors.editedConfig.asObservable,
      ),
      // Ignore duplicate upsert requests while a write is already in flight.
      // Saves should not cancel previous writes or run concurrently.
      rxjs.exhaustMap(([action, context, editedConfig]) => {
        if (!context) {
          return rxjs.of(
            feature.actions.upsert.cancellation.from(action).create({
              reason: 'No scenario context available',
              request: action.data,
            }),
          )
        }
        if (!editedConfig) {
          return rxjs.of(
            feature.actions.upsert.cancellation.from(action).create({
              reason: 'No edited configuration available',
              request: action.data,
            }),
          )
        }

        return feature.api.upsert(context, editedConfig).pipe(
          rxjs.map(response =>
            feature.actions.upsert.success.from(action).create({
              request: action.data,
              response,
            }),
          ),
          rxjs.catchError((error: Error) =>
            rxjs.of(
              feature.actions.upsert.error.from(action).create({
                error,
                request: action.data,
              }),
            ),
          ),
        )
      }),
    ),
)
